import { IoffCuffListStateAction } from "../actions/offCuffListStateAction";
import {
	INITIAL_OFFCUFFLIST_STATE,
	IOffCuffListState,
	OffCuffTabType,
} from "../states/renditionStates";

const offCuffListStateReducer = (
	state: IOffCuffListState = INITIAL_OFFCUFFLIST_STATE,
	action: IoffCuffListStateAction
) => {
	switch (action.type) {
		case "EXPAND_OFFCUFF_ID": {
		    const offcuffData = state.offcuffDataMap[state.currentTabMode];
			   const list = offcuffData?.publications ?? [];
			   const allIDs = list.map((o) => o.pubId);
			   const isAllExpand = allIDs.length === action.value.length;
      return {
                ...state,
                expandAll: isAllExpand,
                openDocIds: action.value,
            };
		}
		case "CHANGE_CURRENT_TAB_MODE": {
		    return {
		        ...state,
		        currentTabMode: action.value,
		    };
		}
        case "REQUEST_OFFCUFFLIST_DATA":
            return { ...state, loading: true };
        case "RECEIVE_OFFCUFFLIST_DATA":
            return {
                ...state,
                offcuffDataMap: {...state.offcuffDataMap, [action.tabType || OffCuffTabType.ByAuthor]: action.value},
                loading: false,
            };
        case "RECEIVE_BYAUTHOR_TOPICS":
           return {...state, byAuthorData: action.value };
        case "RECEIVE_BYALLAUTHORS":
           return {...state, byAllAuthors: action.value };
		case "RECEIVE_OFFCUFF_COPY_URL_DATA":
			return {...state, offCuffCopyURLData: action.value };
		default:
			return state;
	}
};

export default offCuffListStateReducer;
